"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props */
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var client_1 = require("@apollo/client");
var Map_1 = __importDefault(require("../../../Map"));
var index_1 = __importDefault(require("../../index"));
var ContainersDrawerContent = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var query = _a.query, queryVariablesFormatter = _a.queryVariablesFormatter, queryVariables = _a.queryVariables;
    var _y = client_1.useQuery(query, {
        variables: queryVariablesFormatter
            ? queryVariablesFormatter(queryVariables)
            : queryVariables,
    }), loading = _y.loading, data = _y.data;
    console.log("ContainersDrawerContent.data", data);
    if (loading || !data) {
        return (react_1.default.createElement("div", { style: { top: "50%", left: "50%", position: "absolute" } },
            react_1.default.createElement(antd_1.Space, { size: "middle" },
                react_1.default.createElement(antd_1.Spin, { size: "large", tip: "Loading..." }))));
    }
    var container = {
        id: data.container.containerId,
        location: {
            latitude: data.container.location.latitude,
            longitude: data.container.location.longitude,
        },
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Map_1.default, { containers: [container], routes: [], depots: [], vehicles: [], inquiries: [], mapBoxProps: {
                center: {
                    latitude: data.container.location.latitude,
                    longitude: data.container.location.longitude,
                },
                zoom: 10,
            } }),
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { span: 12 },
                react_1.default.createElement("strong", null, "Container Id"),
                react_1.default.createElement("br", null),
                " ",
                ((_b = data.container) === null || _b === void 0 ? void 0 : _b.containerId) || "-"),
            react_1.default.createElement(antd_1.Col, { span: 12 },
                react_1.default.createElement("strong", null, "Container name"),
                react_1.default.createElement("br", null),
                " ",
                ((_d = (_c = data.container) === null || _c === void 0 ? void 0 : _c.containerType) === null || _d === void 0 ? void 0 : _d.name) || "-"),
            react_1.default.createElement(antd_1.Col, { span: 12 },
                react_1.default.createElement("strong", null, "Address"),
                react_1.default.createElement("br", null),
                " ",
                "[Latitude: " + ((_f = (_e = data.container) === null || _e === void 0 ? void 0 : _e.location) === null || _f === void 0 ? void 0 : _f.latitude) + " , Longitude: " + ((_h = (_g = data.container) === null || _g === void 0 ? void 0 : _g.location) === null || _h === void 0 ? void 0 : _h.longitude) + "]" ||
                    "-"),
            react_1.default.createElement(antd_1.Col, { span: 12 },
                react_1.default.createElement("strong", null, "Sensor"),
                react_1.default.createElement("br", null),
                " ",
                ((_o = (_m = (_l = (_k = (_j = data.container) === null || _j === void 0 ? void 0 : _j.deviceToContainerSet) === null || _k === void 0 ? void 0 : _k.edges[0]) === null || _l === void 0 ? void 0 : _l.node) === null || _m === void 0 ? void 0 : _m.device) === null || _o === void 0 ? void 0 : _o.connectionType) || "-"),
            react_1.default.createElement(antd_1.Col, { span: 12 },
                react_1.default.createElement("strong", null, "Pickup setting"),
                react_1.default.createElement("br", null),
                " ",
                ((_q = (_p = data.container) === null || _p === void 0 ? void 0 : _p.pickupSetting) === null || _q === void 0 ? void 0 : _q.name) || "-"),
            react_1.default.createElement(antd_1.Col, { span: 12 },
                react_1.default.createElement("strong", null, "Waste fraction"),
                react_1.default.createElement("br", null),
                " ", (_v = (_u = (_t = (_s = (_r = data === null || data === void 0 ? void 0 : data.container) === null || _r === void 0 ? void 0 : _r.wasteFraction) === null || _s === void 0 ? void 0 : _s.wasteTypes) === null || _t === void 0 ? void 0 : _t.edges[0]) === null || _u === void 0 ? void 0 : _u.node) === null || _v === void 0 ? void 0 :
                _v.name,
                " - ", (_x = (_w = data === null || data === void 0 ? void 0 : data.container) === null || _w === void 0 ? void 0 : _w.wasteFraction) === null || _x === void 0 ? void 0 :
                _x.wasteCategory))));
};
var ContainersDrawer = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, restProps = __rest(_a, ["visible", "onClose"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(index_1.default, { visible: visible, onClose: onClose, title: "Container" },
            react_1.default.createElement(ContainersDrawerContent, __assign({}, restProps)))));
};
exports.default = ContainersDrawer;
